import axios from 'axios';

import { NewBookingData } from '@/v2/bookings/newBooking/newBooking.types.ts';
import { CommunicationDomain, Contact } from '@server/v2/odoo/types';
import {
  BookingListParams,
  BookingListSchema,
  AmendBookingData,
  CancelBookingData,
} from '@/v2/schemas.ts';
import { BookingType } from '@server/v2/odoo/types';
import { BookingEventData } from '@server/v2/odoo/schemas.ts';

export async function listBookings(
  params: BookingListParams
): Promise<BookingEventData[]> {
  const res = await axios.get('/api/v2/bookings', {
    params: BookingListSchema.parse(params),
  });
  return res.data;
}

export async function getBooking(bookingId: string) {
  const res = await axios.get(`/api/v2/bookings/${bookingId}`);
  return res.data;
}

export async function createBooking(booking: NewBookingData) {
  const res = await axios.post('/api/v2/bookings', booking);
  return res.data;
}

export async function amendBooking(
  bookingId: string | number,
  data: AmendBookingData
) {
  const res = await axios.patch(`/api/v2/bookings/${bookingId}`, data);
  return res.data;
}

export async function cancelBooking(
  bookingId: string | number,
  data: CancelBookingData
) {
  const res = await axios.post(`/api/v2/bookings/${bookingId}/cancel`, data);
  return res.data;
}

export async function listCommunicationDomains(): Promise<
  Partial<CommunicationDomain>[]
> {
  const res = await axios.get('/api/v2/communication-domains');
  return res.data;
}

export async function listCommunicationProfessionals(): Promise<
  Partial<Contact>[]
> {
  const res = await axios.get('/api/v2/communication-professionals');
  return res.data;
}

export async function listProfessionalTypes(): Promise<Partial<Contact>[]> {
  const res = await axios.get('/api/v2/professional-types');
  return res.data;
}

export async function listBookingTypes(): Promise<Partial<BookingType>[]> {
  const res = await axios.get('/api/v2/booking-types');
  return res.data;
}
